(function () {
  function initCompareSection(root) {
    if (!root || root.dataset.cpInit === 'true') return;
    root.dataset.cpInit = 'true';

    var dataEl = root.querySelector('[data-compare-json]');
    if (!dataEl) return;

    var products = [];
    try {
      products = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Compare products: invalid JSON', e);
      return;
    }

    var productMap = {};
    products.forEach(function (p) {
      productMap[String(p.id)] = p;
    });

    var bar = root.querySelector('[data-compare-bar]');
    var modal = root.querySelector('[data-compare-modal]');
    var modalColumns = root.querySelector('[data-compare-modal-columns]');
    var columnTemplate = root.querySelector('[data-compare-column-template]');
    var cards = root.querySelectorAll('[data-compare-card]');
    var starIcon = root.dataset.starIcon || '';
    var checkIcon = root.dataset.checkIcon || '';

    var selected = [];
    var sectionInView = true;
    var barUserDismissed = false;
    var modalOpen = false;
    var activeDropdown = null;
    var modalCloseTimer = null;

    function getProduct(id) {
      return productMap[String(id)] || null;
    }

    function selectedIds() {
      return selected.map(function (s) { return String(s.id); });
    }

    function syncCardStates() {
      var ids = selectedIds();
      cards.forEach(function (card) {
        var id = card.getAttribute('data-block-id');
        var btn = card.querySelector('[data-compare-toggle]');
        var active = ids.indexOf(id) !== -1;
        card.classList.toggle('is-compare-active', active);
        if (btn) btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function renderBarSlots() {
      if (!bar) return;
      var slots = bar.querySelectorAll('[data-compare-slot]');
      slots.forEach(function (slot, index) {
        var label = slot.querySelector('.cp-bar__slot-label');
        var thumb = slot.querySelector('.cp-bar__slot-thumb');
        var placeholder = label ? label.getAttribute('data-placeholder') : '';
        var entry = selected[index];
        var product = entry ? getProduct(entry.id) : null;

        if (product && label && thumb) {
          label.textContent = product.titleShort || product.title;
          label.classList.add('is-filled');
          var thumbUrl = product.thumbUrl || product.imageUrl || '';
          if (thumbUrl) {
            thumb.src = thumbUrl;
            thumb.alt = product.title || '';
            thumb.hidden = false;
          } else {
            thumb.hidden = true;
            thumb.removeAttribute('src');
            thumb.removeAttribute('alt');
          }
          slot.classList.add('is-filled');
        } else if (label && thumb) {
          label.textContent = placeholder;
          label.classList.remove('is-filled');
          thumb.hidden = true;
          thumb.removeAttribute('src');
          thumb.removeAttribute('alt');
          slot.classList.remove('is-filled');
        }
      });
    }

    function closeDropdowns() {
      root.querySelectorAll('[data-compare-dropdown]').forEach(function (dd) {
        dd.hidden = true;
      });
      root.querySelectorAll('[data-compare-slot-trigger]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      activeDropdown = null;
    }

    function buildDropdown(slotIndex) {
      var slot = bar.querySelector('[data-compare-slot="' + slotIndex + '"]');
      if (!slot) return;
      var dropdown = slot.querySelector('[data-compare-dropdown]');
      if (!dropdown) return;

      var ids = selectedIds();
      var currentId = selected[slotIndex] ? selected[slotIndex].id : null;
      dropdown.innerHTML = '';

      products.forEach(function (product) {
        if (ids.indexOf(product.id) !== -1 && product.id !== currentId) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cp-bar__dropdown-item';
        btn.dataset.productId = String(product.id);

        if (product.thumbUrl) {
          var img = document.createElement('img');
          img.src = product.thumbUrl;
          img.alt = '';
          img.width = 50;
          img.height = 50;
          btn.appendChild(img);
        }

        var span = document.createElement('span');
        span.textContent = product.titleShort || product.title;
        btn.appendChild(span);

        btn.addEventListener('click', function () {
          selectForSlot(slotIndex, product.id);
          closeDropdowns();
        });

        dropdown.appendChild(btn);
      });

      if (!dropdown.children.length) {
        var empty = document.createElement('p');
        empty.className = 'cp-bar__dropdown-empty';
        empty.textContent = root.dataset.emptyDropdown || 'No more products';
        dropdown.appendChild(empty);
      }
    }

    function shouldShowBar() {
      return selected.length > 0 && sectionInView && !barUserDismissed && !modalOpen;
    }

    function updateBarVisibility() {
      if (!bar) return;
      if (shouldShowBar()) {
        bar.classList.remove('is-hidden');
        bar.setAttribute('aria-hidden', 'false');
        root.classList.add('cp-section--bar-visible');
      } else {
        bar.classList.add('is-hidden');
        bar.setAttribute('aria-hidden', 'true');
        root.classList.remove('cp-section--bar-visible');
        closeDropdowns();
      }
    }

    function showBar() {
      barUserDismissed = false;
      updateBarVisibility();
    }

    function hideBarOnly() {
      barUserDismissed = true;
      updateBarVisibility();
    }

    function selectForSlot(slotIndex, productId) {
      productId = String(productId);
      var ids = [null, null];
      if (selected[0]) ids[0] = selected[0].id;
      if (selected[1]) ids[1] = selected[1].id;
      ids[slotIndex] = productId;
      if (ids[0] && ids[1] && ids[0] === ids[1]) {
        if (slotIndex === 0) ids[1] = null;
        else ids[0] = null;
      }
      selected = [];
      if (ids[0]) selected.push({ id: ids[0], ts: Date.now() });
      if (ids[1]) selected.push({ id: ids[1], ts: Date.now() + 1 });
      if (selected.length) showBar();
      else updateBarVisibility();
      syncCardStates();
      renderBarSlots();
      if (selected.length < 2 && modalOpen) closeModal();
      maybeOpenModal();
    }

    function toggleCompare(productId) {
      productId = String(productId);
      var idx = selected.findIndex(function (s) { return s.id === productId; });
      if (idx !== -1) {
        selected.splice(idx, 1);
      } else if (selected.length >= 2) {
        selected.shift();
        selected.push({ id: productId, ts: Date.now() });
      } else {
        selected.push({ id: productId, ts: Date.now() });
      }

      if (selected.length) showBar();
      else updateBarVisibility();
      syncCardStates();
      renderBarSlots();
      if (selected.length < 2 && modalOpen) closeModal();
      maybeOpenModal();
    }

    function renderStars(rating) {
      var value = Math.max(0, Math.min(5, Number(rating) || 0));
      if (!value || !starIcon) return '';
      var html = '<span class="cp-modal-col__stars">';
      for (var i = 1; i <= 5; i++) {
        var fill = Math.max(0, Math.min(1, value - (i - 1)));
        var fillWidth = Math.round(fill * 100);
        html += '<span class="cp-modal-col__star" aria-hidden="true">';
        html += '<span class="cp-modal-col__star-base"><img src="' + starIcon + '" alt="" width="14" height="14"></span>';
        html += '<span class="cp-modal-col__star-fill" style="width:' + fillWidth + '%;"><img src="' + starIcon + '" alt="" width="14" height="14"></span>';
        html += '</span>';
      }
      html += '</span>';
      return html;
    }

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[char];
      });
    }

    function renderReviewCount(reviewCount) {
      if (!reviewCount) return '';
      return '<span class="cp-modal-col__reviews">' + escapeHtml(reviewCount) + '</span>';
    }

    function normalizeRating(value) {
      var rating = Number(value);
      if (!rating || rating < 0) return '';
      if (rating > 5 && rating <= 100) rating = rating / 20;
      if (rating > 5) return '';
      return Math.round(rating * 10) / 10;
    }

    function findRatingMetric(data, type) {
      var ratingKeys = ['average_rating', 'averageRating', 'avg_rating', 'avgRating', 'avgRate', 'rating', 'rate', 'score', 'star'];
      var countKeys = ['review_count', 'reviewCount', 'reviews_count', 'reviewsCount', 'count', 'total', 'totalReview', 'totalReviews'];
      var keys = type === 'count' ? countKeys : ratingKeys;

      function walk(value, depth, matchedKey) {
        if (value == null || depth > 4) return '';
        if (typeof value === 'string' || typeof value === 'number') {
          if (!matchedKey) return '';
          return type === 'rating' ? normalizeRating(value) : value;
        }
        if (Array.isArray(value)) {
          for (var i = 0; i < value.length; i++) {
            var arrayResult = walk(value[i], depth + 1, matchedKey);
            if (arrayResult) return arrayResult;
          }
          return '';
        }
        if (typeof value === 'object') {
          for (var k = 0; k < keys.length; k++) {
            if (Object.prototype.hasOwnProperty.call(value, keys[k])) {
              var direct = walk(value[keys[k]], depth + 1, true);
              if (direct) return direct;
            }
          }
          for (var key in value) {
            if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
            var nested = walk(value[key], depth + 1, false);
            if (nested) return nested;
          }
        }
        return '';
      }

      return walk(data, 0, false);
    }

    function renderRatingFallback(product) {
      var data = product.ratingData;
      var rating = normalizeRating(product.rating);
      var reviewCount = product.reviewCount || '';
      if (!rating) rating = findRatingMetric(data, 'rating');
      if (!reviewCount) reviewCount = findRatingMetric(data, 'count');
      var starsHtml = renderStars(rating);
      var reviewsHtml = renderReviewCount(reviewCount);
      return starsHtml || reviewsHtml
        ? '<span class="cp-modal-col__rating">' + starsHtml + reviewsHtml + '</span>'
        : '';
    }

    function getPluginReview(product) {
      return {
        widgetHtml: product.ratingWidgetHtml,
        fallbackHtml: renderRatingFallback(product),
        hasDirectSummary: !!(normalizeRating(product.rating) || product.reviewCount)
      };
    }

    function refreshRatingWidgets() {
      requestAnimationFrame(function () {
        try {
          if (window.SCMReview && typeof window.SCMReview.init === 'function') {
            window.SCMReview.init();
          } else if (window.SCMReviews && typeof window.SCMReviews.init === 'function') {
            window.SCMReviews.init();
          } else if (window.scmReviews && typeof window.scmReviews.init === 'function') {
            window.scmReviews.init();
          }
          document.dispatchEvent(new CustomEvent('scm:reviews:refresh'));
        } catch (err) {
          return;
        }
      });
    }

    function hideRatingFallbackWhenWidgetRenders(rating) {
      setTimeout(function () {
        var widget = rating.querySelector('.t4s-product-rating, .scm-reviews-rate, .ryviu-collection, .loox-rating, .jdgm-widget');
        var fallback = rating.querySelector('.cp-modal-col__rating');
        if (widget && fallback && widget.textContent.trim()) {
          fallback.hidden = true;
        }
      }, 500);
    }

    function fillColumn(column, product) {
      if (!product) return;

      var image = column.querySelector('[data-field="image"]');
      if (image) {
        image.src = product.imageUrl || '';
        image.alt = product.title || '';
      }

      var title = column.querySelector('[data-field="title"]');
      if (title) title.textContent = product.modalTitle || product.title || '';

      var points = column.querySelector('[data-field="points"]');
      if (points) {
        points.innerHTML = (product.sellingPoints || []).map(function (point) {
          return '<li><img src="' + checkIcon + '" alt="" width="16" height="16"><span>' + point + '</span></li>';
        }).join('');
      }

      var price = column.querySelector('[data-field="price"]');
      if (price) {
        price.innerHTML = product.priceHtml || '';
      }

      var rating = column.querySelector('[data-field="rating"]');
      if (rating) {
        var pluginReview = getPluginReview(product);
        if (pluginReview.widgetHtml) {
          rating.innerHTML = pluginReview.widgetHtml + pluginReview.fallbackHtml;
          refreshRatingWidgets();
          hideRatingFallbackWhenWidgetRenders(rating);
        } else {
          rating.innerHTML = pluginReview.fallbackHtml;
        }
      }

      var goodFor = column.querySelector('[data-field="goodFor"]');
      if (goodFor) {
        goodFor.innerHTML = (product.goodFor || []).map(function (tag) {
          return '<span class="cp-modal-col__tag">' + tag + '</span>';
        }).join('');
      }

      var highlights = column.querySelector('[data-field="highlights"]');
      if (highlights) {
        highlights.innerHTML = (product.highlights || []).map(function (item) {
          return '<div class="cp-modal-col__highlight">' +
            (item.icon ? '<img src="' + item.icon + '" alt="" width="40" height="40">' : '') +
            '<span>' + item.text + '</span></div>';
        }).join('');
      }

      var features = column.querySelector('[data-field="features"]');
      if (features) {
        features.innerHTML = (product.features || []).map(function (feature) {
          return '<li>' + feature + '</li>';
        }).join('');
      }

      var dimensions = column.querySelector('[data-field="dimensions"]');
      if (dimensions) {
        var dims = product.dimensions || [];
        if (!Array.isArray(dims)) dims = dims ? [dims] : [];
        dimensions.textContent = dims.join(', ');
      }

      var weight = column.querySelector('[data-field="weight"]');
      if (weight) weight.textContent = product.weight || '';

      var learn = column.querySelector('[data-field="learnMore"]');
      if (learn) {
        learn.textContent = product.learnMoreText || 'Learn More';
        learn.href = product.learnMoreUrl || '#';
      }
    }

    function bindNestedScroll(viewport) {
      if (!viewport || viewport.dataset.cpScrollInit === 'true') return;
      viewport.dataset.cpScrollInit = 'true';
      viewport.addEventListener('wheel', function (e) {
        var maxScroll = viewport.scrollHeight - viewport.clientHeight;
        if (maxScroll <= 0) return;
        var goingDown = e.deltaY > 0;
        var goingUp = e.deltaY < 0;
        var atTop = viewport.scrollTop <= 0;
        var atBottom = viewport.scrollTop >= maxScroll - 1;
        if ((goingDown && !atBottom) || (goingUp && !atTop)) {
          e.stopPropagation();
        }
      }, { passive: true });
    }

    function measureViewportNatural(viewport) {
      var prevHeight = viewport.style.height;
      var prevMaxHeight = viewport.style.maxHeight;
      viewport.style.height = 'auto';
      viewport.style.maxHeight = 'none';
      var content = viewport.firstElementChild;
      var natural = content ? content.scrollHeight : viewport.scrollHeight;
      viewport.style.height = prevHeight;
      viewport.style.maxHeight = prevMaxHeight;
      return natural;
    }

    function observeScrollContent(viewport) {
      var content = viewport.firstElementChild;
      if (!content || content.dataset.cpResizeObserved === 'true') return;
      content.dataset.cpResizeObserved = 'true';
      if (typeof ResizeObserver === 'undefined') return;
      var capKey = viewport.getAttribute('data-scroll-cap');
      if (!capKey) return;
      var observer = new ResizeObserver(function () {
        if (!modalOpen) return;
        syncScrollSection(capKey, capKey);
      });
      observer.observe(content);
    }

    function syncScrollSection(capKey, syncSectionKey) {
      if (!modalColumns) return;
      var maxCap = getScrollViewportMaxHeight(capKey);
      var viewports = modalColumns.querySelectorAll('[data-compare-scroll-viewport][data-scroll-cap="' + capKey + '"]');
      if (!viewports.length) return;

      viewports.forEach(function (vp) {
        var natural = measureViewportNatural(vp);
        var needsScroll = natural > maxCap + 1;
        vp.style.height = needsScroll ? maxCap + 'px' : '';
        bindNestedScroll(vp);
        observeScrollContent(vp);
      });

      syncSectionGroup(syncSectionKey);
    }

    function resetSyncHeights() {
      if (!modalColumns) return;
      modalColumns.querySelectorAll('[data-compare-sync-section]').forEach(function (el) {
        el.style.minHeight = '';
      });
      modalColumns.querySelectorAll('[data-compare-scroll-viewport]').forEach(function (el) {
        el.style.height = '';
      });
    }

    function getScrollViewportMaxHeight(capKey) {
      var styles = window.getComputedStyle(root);
      var val = parseFloat(styles.getPropertyValue('--cp-' + capKey + '-viewport-max-h'));
      if (!isNaN(val) && val > 0) return val;
      var isPC = window.matchMedia('(min-width: 745px)').matches;
      if (capKey === 'highlights') return isPC ? 90 : 156;
      return isPC ? 110 : 125;
    }

    function syncSectionGroup(key) {
      if (!modalColumns) return;
      var els = modalColumns.querySelectorAll('[data-compare-sync-section="' + key + '"]');
      if (els.length < 2) return;
      var maxH = 0;
      els.forEach(function (el) {
        maxH = Math.max(maxH, el.offsetHeight);
      });
      els.forEach(function (el) {
        el.style.minHeight = maxH + 'px';
      });
    }

    function syncFeaturesSection() {
      syncScrollSection('features', 'features');
    }

    function syncHighlightsSection() {
      syncScrollSection('highlights', 'highlights');
    }

    function syncModalColumnHeights() {
      if (!modalColumns) return;
      isSyncingHeights = true;
      resetSyncHeights();
      ['title', 'points', 'price-row', 'head', 'good-for', 'dimensions', 'weight'].forEach(syncSectionGroup);
      syncHighlightsSection();
      syncFeaturesSection();
      requestAnimationFrame(function () {
        isSyncingHeights = false;
      });
    }

    var syncObserver;
    var isSyncingHeights = false;

    function observeSyncedSections() {
      if (!modalColumns || typeof ResizeObserver === 'undefined') return;
      if (syncObserver) syncObserver.disconnect();
      syncObserver = new ResizeObserver(function () {
        if (!modalOpen || isSyncingHeights) return;
        clearTimeout(resizeSyncTimer);
        resizeSyncTimer = setTimeout(syncModalColumnHeights, 50);
      });
      modalColumns.querySelectorAll('[data-compare-sync-section]').forEach(function (el) {
        syncObserver.observe(el);
      });
    }

    function bindModalImagesForSync() {
      if (!modalColumns) return;
      modalColumns.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', syncModalColumnHeights, { once: true });
        }
      });
    }

    var resizeSyncTimer;
    window.addEventListener('resize', function () {
      if (!modalOpen) return;
      clearTimeout(resizeSyncTimer);
      resizeSyncTimer = setTimeout(function () {
        syncModalColumnHeights();
      }, 100);
    });

    function renderModal() {
      if (!modalColumns || !columnTemplate) return;
      modalColumns.innerHTML = '';

      selected.slice(0, 2).forEach(function (entry) {
        var product = getProduct(entry.id);
        if (!product) return;
        var fragment = columnTemplate.content.cloneNode(true);
        var column = fragment.querySelector('[data-compare-column]');
        fillColumn(column, product);
        modalColumns.appendChild(fragment);
      });

      bindModalImagesForSync();
      observeSyncedSections();
    }

    function openModal() {
      if (!modal || selected.length < 2) return;
      if (modalCloseTimer) {
        clearTimeout(modalCloseTimer);
        modalCloseTimer = null;
      }
      renderModal();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modalOpen = true;
      root.classList.add('cp-section--modal-open');
      document.body.style.overflow = 'hidden';
      updateBarVisibility();

      var modalScroll = modal.querySelector('[data-compare-modal-scroll]');
      if (modalScroll) modalScroll.scrollTop = 0;

      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        requestAnimationFrame(function () {
          syncModalColumnHeights();
          var modalScroll = modal.querySelector('[data-compare-modal-scroll]');
          if (modalScroll) bindNestedScroll(modalScroll);
          setTimeout(function () {
            syncModalColumnHeights();
          }, 150);
        });
      });
    }

    function closeModal() {
      if (!modal || !modalOpen) return;
      modal.classList.remove('is-open');
      modalOpen = false;
      root.classList.remove('cp-section--modal-open');
      document.body.style.overflow = '';
      updateBarVisibility();

      modalCloseTimer = setTimeout(function () {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        modalCloseTimer = null;
      }, 300);
    }

    function maybeOpenModal() {
      if (selected.length === 2) openModal();
    }

    cards.forEach(function (card) {
      var id = card.getAttribute('data-block-id');
      var compareBtn = card.querySelector('[data-compare-toggle]');
      if (!getProduct(id)) {
        card.removeAttribute('data-compare-card');
        if (compareBtn) {
          compareBtn.hidden = true;
          compareBtn.disabled = true;
        }
        return;
      }
      if (compareBtn) {
        compareBtn.addEventListener('click', function (e) {
          e.preventDefault();
          toggleCompare(id);
        });
      }

      var buyBtn = card.querySelector('[data-compare-buy]');
      if (buyBtn) {
        buyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var variantId = buyBtn.getAttribute('data-variant-id');
          var giftId = buyBtn.getAttribute('data-gift-variant-id');
          if (!variantId || buyBtn.classList.contains('is-loading')) return;

          var items = [{ id: Number(variantId), quantity: 1 }];
          if (giftId) items.push({ id: Number(giftId), quantity: 1 });

          buyBtn.classList.add('is-loading');
          buyBtn.disabled = true;
          buyBtn.setAttribute('aria-busy', 'true');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add failed');
              return res.json();
            })
            .then(function () {
              window.location.href = '/checkout';
            })
            .catch(function (err) {
              console.error(err);
              buyBtn.classList.remove('is-loading');
              buyBtn.disabled = false;
              buyBtn.removeAttribute('aria-busy');
            });
        });
      }
    });

    root.querySelectorAll('[data-compare-bar-close]').forEach(function (btn) {
      btn.addEventListener('click', hideBarOnly);
    });

    if ('IntersectionObserver' in window) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        sectionInView = entries[0].isIntersecting;
        updateBarVisibility();
      }, { threshold: 0 });
      sectionObserver.observe(root);
    }

    root.querySelectorAll('[data-compare-slot-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var slotIndex = trigger.getAttribute('data-compare-slot-trigger');
        var slot = bar.querySelector('[data-compare-slot="' + slotIndex + '"]');
        var dropdown = slot ? slot.querySelector('[data-compare-dropdown]') : null;
        if (!dropdown) return;

        var willOpen = dropdown.hidden;
        closeDropdowns();
        if (!willOpen) return;

        buildDropdown(Number(slotIndex));
        dropdown.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        activeDropdown = dropdown;
      });
    });

    root.querySelectorAll('[data-compare-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('click', function (e) {
      if (!activeDropdown || !bar) return;
      if (bar.contains(e.target)) return;
      closeDropdowns();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDropdowns();
        if (modalOpen) closeModal();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-compare-section]').forEach(initCompareSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-compare-section]');
    if (section) initCompareSection(section);
  });
})();
